/** Product descriptions — key must match model code from image filename (e.g. AJ-AL-131). */export const productDescriptions = {
  'AJ-AL-131': {
    features: [
      'High-performance elevated work platform for safe operations at height',
      'Advanced hydraulic lifting with smooth vertical movement',
      'User-friendly controls and robust platform design',
      'Compact, durable structure for hard-to-reach indoor & outdoor areas',
      'Ideal for maintenance, installation, painting, and facility management',
    ],
    paragraphs: [
      'The AJ-AL-131 Aerial Lift is a high-performance elevated work platform designed for safe and efficient operations at height. Built for industrial, warehouse, maintenance, and construction applications, this lift delivers excellent stability, smooth vertical movement, and reliable performance in demanding environments. Its compact yet durable structure allows operators to access hard-to-reach areas with ease while maintaining maximum safety and productivity.',
      'Featuring advanced hydraulic lifting technology, user-friendly controls, and a robust platform design, the AJ-AL-131 is ideal for indoor and outdoor tasks such as installation work, equipment maintenance, painting, electrical servicing, and facility management. The lift is engineered to provide enhanced maneuverability, operator comfort, and dependable operation for daily professional use.',
    ],
  },
  'AJ-DAL-132': {
    features: [
      'High-strength and durable structure',
      'Smooth and stable lifting mechanism',
      'Easy-to-use operator controls',
      'Suitable for indoor and outdoor applications',
      'Enhanced safety and operational efficiency',
    ],
    paragraphs: [
      'The AJ-DAL-132 Aerial Lift is a reliable and efficient lifting solution designed for safe elevated work in industrial, maintenance, and construction environments. It offers smooth lifting performance, strong stability, and easy operation for improved productivity at height.',
    ],
  },
  'AJ-HDL-161': {
    features: [
      'Heavy-duty construction for long-lasting durability',
      'Smooth and reliable hydraulic lifting system',
      'Ensures safe loading and unloading operations',
      'Designed for high-volume industrial use',
      'Easy operation with minimal maintenance requirements',
    ],
    paragraphs: [
      'The AJ-HDL-161 Dock Leveller is a robust and efficient loading platform designed to bridge the height gap between warehouse floors and transport vehicles. Engineered for smooth material handling operations, it enhances safety, productivity, and loading efficiency in warehouses, distribution centers, and industrial facilities.',
    ],
  },
  'AJ-EEDL-162': {
    features: [
      'Strong and durable heavy-duty steel construction',
      'Smooth hydraulic lifting operation',
      'Safe and efficient loading/unloading support',
      'Suitable for warehouses and industrial loading bays',
      'Low maintenance with reliable long-term performance',
    ],
    paragraphs: [
      'The AJ-EEDL-162 Dock Leveller is a heavy-duty loading bay solution designed to ensure smooth and safe movement of goods between trucks and warehouse floors. Built for high performance and durability, it improves loading efficiency while minimizing operational downtime in warehouses, logistics hubs, and industrial facilities.',
    ],
  },
  'AJ-MDL-163': {
    features: [
      'Heavy-duty steel construction',
      'Smooth loading and unloading support',
      'Durable and long-lasting performance',
      'Suitable for warehouses and logistics centers',
      'Low maintenance design',
    ],
    paragraphs: [
      'The AJ-MDL-163 Dock Leveller is a reliable loading platform designed to bridge the gap between trucks and warehouse floors for smooth and safe material handling operations.',
    ],
  },
  'AJ-EDLCT-172': {
    features: [
      'Easy drum lifting and tilting mechanism',
      'Strong and durable frame construction',
      'Smooth maneuverability with wheels',
      'Safe handling for industrial applications',
      'User-friendly operation',
    ],
    paragraphs: [
      'The AJ-EDLCT-172 Drum Handling Equipment is designed for safe lifting, tilting, and transportation of industrial drums with improved efficiency and operator safety.',
    ],
  },
  'AJ-FEDLCT-173': {
    features: [
      'Efficient drum lifting system',
      'Stable and secure drum support',
      'Heavy-duty industrial design',
      'Easy mobility and operation',
      'Suitable for loading and stacking tasks',
    ],
    paragraphs: [
      'The AJ-FEDLCT-173 Drum Handling Unit offers efficient drum lifting and stacking operations for warehouses, factories, and industrial environments.',
    ],
  },
  'AJ-HDS-174': {
    features: [
      'Secure drum gripping mechanism',
      'Compact and easy-to-move design',
      'Durable industrial-grade structure',
      'Smooth handling and positioning',
      'Enhanced operator safety',
    ],
    paragraphs: [
      'The AJ-HDS-174 Drum Handling System is built for safe transportation and positioning of heavy drums in industrial and warehouse applications.',
    ],
  },
  'AJ-MDLCT-171': {
    features: [
      'Strong drum clamping support',
      'Smooth lifting and tilting operation',
      'Heavy-duty steel body',
      'Easy maneuverability',
      'Ideal for industrial drum handling',
    ],
    paragraphs: [
      'The AJ-MDLCT-171 Drum Handling Equipment is designed for easy drum lifting, tilting, and movement with high stability and operational efficiency.',
    ],
  },
  'AJHDT-175': {
    features: [
      'Compact and lightweight design',
      'Smooth wheel movement for easy transport',
      'Durable frame construction',
      'Easy drum loading and unloading',
      'Suitable for warehouses and factories',
    ],
    paragraphs: [
      'The AJHDT-175 Drum Trolley is a compact and efficient solution for transporting and handling industrial drums safely and conveniently.',
    ],
  },
  'AJ-EC-141': {
    features: [
      'Strong hydraulic lifting mechanism',
      'Heavy-duty steel construction',
      'Smooth and stable operation',
      'Easy mobility with caster wheels',
      'Suitable for lifting heavy equipment',
    ],
    paragraphs: [
      'The AJ-EC-141 Floor Crane is a heavy-duty lifting solution designed for safe and efficient material handling in workshops, warehouses, and industrial facilities.',
    ],
  },
  'AJ-EFC-144': {
    features: [
      'High lifting capacity and stability',
      'Durable industrial-grade structure',
      'Smooth hydraulic operation',
      'Easy maneuverability and positioning',
      'Designed for warehouse and workshop use',
    ],
    paragraphs: [
      'The AJ-EFC-144 Floor Crane is an efficient lifting and material handling system built for industrial applications requiring reliable performance and safe load handling.',
    ],
  },
  'AJ-MFC-142': {
    features: [
      'Strong hydraulic lifting system',
      'Compact and easy-to-move design',
      'Heavy-duty steel construction',
      'Smooth lifting and lowering operation',
      'Suitable for industrial material handling',
    ],
    paragraphs: [
      'The AJ-MFC-142 Floor Crane is a compact and durable lifting solution designed for safe material handling and equipment lifting in industrial and warehouse environments.',
    ],
  },
  'AJ-SEFC-143': {
    features: [
      'Reliable hydraulic lifting mechanism',
      'High load handling capability',
      'Durable industrial-grade structure',
      'Easy maneuverability with caster wheels',
      'Ideal for workshops and warehouses',
    ],
    paragraphs: [
      'The AJ-SEFC-143 Floor Crane is an efficient mobile lifting crane built for handling heavy loads with stability, precision, and operator safety.',
    ],
  },
  'AJ-DGL-152': {
    features: [
      'Smooth vertical lifting operation',
      'Strong and stable platform structure',
      'Suitable for warehouses and factories',
      'Safe and efficient goods transportation',
      'Durable low-maintenance design',
    ],
    paragraphs: [
      'The AJ-DGL-152 Goods Lift is a heavy-duty vertical lifting solution designed for safe and efficient transportation of goods between multiple floor levels.',
    ],
  },
  'AJ-GL-151': {
    features: [
      'Compact space-saving design',
      'Smooth and stable lifting mechanism',
      'Durable steel body construction',
      'Safe material transportation',
      'Suitable for industrial and warehouse use',
    ],
    paragraphs: [
      'The AJ-GL-151 Goods Lift is a compact and reliable lifting system developed for transporting materials safely across different floor levels in industrial facilities.',
    ],
  },
  'AJ-WGL-153': {
    features: [
      'Heavy-duty lifting platform',
      'Stable and secure operation',
      'High durability for industrial applications',
      'Smooth lifting performance',
      'Designed for warehouses and manufacturing units',
    ],
    paragraphs: [
      'The AJ-WGL-153 Goods Lift is a robust industrial lifting platform engineered for efficient vertical movement of heavy materials and goods.',
    ],
  },
  'AJ-BOPT-107': {
    features: [
      'Battery-operated driving system',
      'Easy pallet transportation',
      'Compact and operator-friendly design',
      'Smooth and efficient movement',
      'Ideal for warehouse operations',
    ],
    paragraphs: [
      'The AJ-BOPT-107 Pallet Truck is an efficient battery-operated material handling solution designed for smooth pallet movement in warehouses and logistics operations.',
    ],
  },
  'AJ-CPT-102': {
    features: [
      'Heavy-duty steel construction',
      'Smooth wheel movement',
      'Easy manual operation',
      'Reliable pallet handling performance',
      'Suitable for warehouses and retail storage',
    ],
    paragraphs: [
      'The AJ-CPT-102 Pallet Truck is a durable manual pallet handling tool designed for quick and efficient transportation of palletized goods.',
    ],
  },
  'AJ-HLPT-104': {
    features: [
      'High lifting functionality',
      'Smooth hydraulic lifting mechanism',
      'Durable and stable construction',
      'Easy pallet movement and positioning',
      'Suitable for warehouses and industrial use',
    ],
    paragraphs: [
      'The AJ-HLPT-104 High Lift Pallet Truck combines pallet transportation and lifting functions, making it ideal for material handling and ergonomic loading tasks.',
    ],
  },
  'AJ-HPT-101': {
    features: [
      'Heavy-duty steel construction',
      'Smooth wheel movement',
      'Easy manual operation',
      'Reliable pallet transportation',
      'Suitable for warehouse applications',
    ],
    paragraphs: [
      'The AJ-HPT-101 Pallet Truck is a durable and easy-to-operate manual pallet handling solution designed for efficient movement of goods in warehouses and industrial facilities.',
    ],
  },
  'AJ-PRPT-103': {
    features: [
      'Strong and durable frame',
      'Smooth hydraulic lifting system',
      'Easy maneuverability',
      'Low maintenance design',
      'Ideal for industrial and retail storage use',
    ],
    paragraphs: [
      'The AJ-PRPT-103 Pallet Truck is a compact and reliable material handling tool built for safe and efficient transportation of palletized loads.',
    ],
  },
  'AJ-SSHLPT-106': {
    features: [
      'Stainless steel body construction',
      'High lift functionality',
      'Corrosion-resistant design',
      'Smooth lifting and movement',
      'Suitable for hygienic workspaces',
    ],
    paragraphs: [
      'The AJ-SSHLPT-106 Stainless Steel High Lift Pallet Truck is designed for hygienic and efficient pallet handling in food, pharmaceutical, and cleanroom environments.',
    ],
  },
  'AJ-SSPT-105': {
    features: [
      'Stainless steel durable structure',
      'Corrosion-resistant finish',
      'Smooth and easy operation',
      'Strong load handling capability',
      'Ideal for clean and wet environments',
    ],
    paragraphs: [
      'The AJ-SSPT-105 Stainless Steel Pallet Truck offers reliable pallet transportation with excellent corrosion resistance and durability for specialized industrial applications.',
    ],
  },
  'AJ-FWPT-191': {
    features: [
      'Strong load-carrying platform',
      'Easy steering and control',
      'Durable wheel construction',
      'Compact and user-friendly design',
      'Suitable for warehouse transportation',
    ],
    paragraphs: [
      'The AJ-FWPT-191 Platform Trolley is a versatile material transport solution designed for easy movement of goods across warehouses, factories, and commercial spaces.',
    ],
  },
  'AJ-MSL-122': {
    features: [
      'Smooth hydraulic lifting mechanism',
      'Stable scissor platform design',
      'Heavy-duty steel construction',
      'Safe elevated working support',
      'Suitable for industrial applications',
    ],
    paragraphs: [
      'The AJ-MSL-122 Scissor Lift is a reliable lifting platform designed for safe elevated work and material handling in industrial and maintenance operations.',
    ],
  },
  'AJ-MSLM-124': {
    features: [
      'Mobile elevated work platform',
      'Stable and secure lifting system',
      'Easy maneuverability',
      'Durable industrial-grade structure',
      'Suitable for indoor and outdoor use',
    ],
    paragraphs: [
      'The AJ-MSLM-124 Mobile Scissor Lift provides efficient elevated access for maintenance, installation, and warehouse operations with enhanced mobility and safety.',
    ],
  },
  'AJ-PSL-123': {
    features: [
      'Heavy-duty lifting platform',
      'Stable hydraulic lifting system',
      'Safe and efficient operation',
      'Durable steel body construction',
      'Ideal for warehouses and factories',
    ],
    paragraphs: [
      'The AJ-PSL-123 Scissor Lift is a powerful lifting solution designed for smooth vertical movement of heavy loads and elevated work operations.',
    ],
  },
  'AJ-SDL-121': {
    features: [
      'Smooth lifting and lowering operation',
      'Compact and movable design',
      'Durable platform construction',
      'Easy handling and positioning',
      'Suitable for material handling tasks',
    ],
    paragraphs: [
      'The AJ-SDL-121 Scissor Lift Table is an ergonomic lifting solution designed to improve productivity and reduce manual handling effort in industrial operations.',
    ],
  },
  'AJ-SPSL-125': {
    features: [
      'Self-propelled movement system',
      'Stable elevated working platform',
      'Compact and easy-to-operate design',
      'Reliable lifting performance',
      'Suitable for maintenance and installation work',
    ],
    paragraphs: [
      'The AJ-SPSL-125 Scissor Lift is a compact self-propelled lifting platform designed for efficient elevated access and maintenance work.',
    ],
  },
  'AJ-FES-114': {
    features: [
      'Smooth electric lifting operation',
      'Strong and stable mast structure',
      'Easy pallet stacking and handling',
      'Compact maneuverable design',
      'Suitable for warehouse operations',
    ],
    paragraphs: [
      'The AJ-FES-114 Stacker is an efficient material handling machine designed for lifting, stacking, and transporting pallets safely in warehouses and industrial facilities.',
    ],
  },
  'AJ-FEST-117': {
    features: [
      'Electric-powered lifting system',
      'Durable and stable construction',
      'Easy maneuverability in narrow spaces',
      'Smooth and efficient pallet handling',
      'Ideal for warehouses and logistics centers',
    ],
    paragraphs: [
      'The AJ-FEST-117 Electric Stacker is a high-performance lifting solution built for efficient pallet stacking and transportation with minimal operator effort.',
    ],
  },
  'AJ-HCS-119': {
    features: [
      'Hydraulic lifting mechanism',
      'Protective cage platform design',
      'Strong and durable structure',
      'Smooth handling operation',
      'Suitable for industrial material movement',
    ],
    paragraphs: [
      'The AJ-HCS-119 Hydraulic Cage Stacker is designed for safe lifting and transportation of heavy materials with enhanced load protection and operational safety.',
    ],
  },
  'AJ-HRS-118': {
    features: [
      'Smooth hydraulic lifting system',
      'Durable roller platform support',
      'Easy handling and positioning',
      'Compact industrial design',
      'Suitable for warehouse operations',
    ],
    paragraphs: [
      'The AJ-HRS-118 Hydraulic Roller Stacker is a reliable material handling solution designed for lifting and positioning heavy loads efficiently.',
    ],
  },
  'AJ-MHS-111': {
    features: [
      'Manual hydraulic lifting mechanism',
      'Strong and durable mast structure',
      'Easy pallet handling operation',
      'Compact and user-friendly design',
      'Suitable for warehouses and storage areas',
    ],
    paragraphs: [
      'The AJ-MHS-111 Manual Hydraulic Stacker is a cost-effective lifting solution designed for pallet stacking and material handling in industrial environments.',
    ],
  },
  'AJ-PRS-120': {
    features: [
      'Strong lifting and support system',
      'Stable material positioning',
      'Durable industrial-grade structure',
      'Easy movement and handling',
      'Suitable for reel and roll handling applications',
    ],
    paragraphs: [
      'The AJ-PRS-120 Platform Reel Stacker is designed for safe lifting and handling of reels, rolls, and heavy industrial materials with improved efficiency.',
    ],
  },
  'AJ-SBS-113': {
    features: [
      'Strong and stable lifting mechanism',
      'Durable industrial-grade structure',
      'Smooth pallet handling operation',
      'Compact and easy-to-maneuver design',
      'Suitable for warehouse applications',
    ],
    paragraphs: [
      'The AJ-SBS-113 Stacker is a reliable material handling solution designed for efficient pallet lifting, stacking, and transportation in warehouses and industrial facilities.',
    ],
  },
  'AJ-SLHS-115': {
    features: [
      'Smooth hydraulic lifting operation',
      'Heavy-duty mast construction',
      'Easy pallet positioning and handling',
      'Durable and low-maintenance design',
      'Ideal for warehouse and storage use',
    ],
    paragraphs: [
      'The AJ-SLHS-115 Stacker is a high-performance lifting system designed for safe and efficient stacking of heavy materials in industrial environments.',
    ],
  },
  'AJ-THS-112': {
    features: [
      'Compact and ergonomic design',
      'Strong lifting support system',
      'Easy maneuverability in narrow spaces',
      'Durable steel construction',
      'Suitable for industrial material handling',
    ],
    paragraphs: [
      'The AJ-THS-112 Stacker is a compact and efficient lifting solution built for smooth pallet transportation and stacking operations.',
    ],
  },
  'AJ-WS-116': {
    features: [
      'Smooth lifting and lowering mechanism',
      'Stable and secure load handling',
      'Heavy-duty industrial structure',
      'Easy-to-operate controls',
      'Ideal for warehouse and logistics operations',
    ],
    paragraphs: [
      'The AJ-WS-116 Stacker is a durable warehouse stacking solution designed for reliable lifting and efficient movement of palletized goods.',
    ],
  },
  'AJ-GCT-181': {
    features: [
      'Strong load-carrying platform',
      'Smooth wheel movement',
      'Durable steel frame construction',
      'Easy handling and maneuverability',
      'Suitable for warehouses and factories',
    ],
    paragraphs: [
      'The AJ-GCT-181 Trolley is a practical and durable transport solution designed for smooth movement of materials and goods in industrial and commercial environments.',
    ],
  },
  'AJ-PFPT-182': {
    features: [
      'Heavy-duty platform structure',
      'Easy steering and movement',
      'Durable wheel assembly',
      'Compact and user-friendly design',
      'Ideal for industrial transportation tasks',
    ],
    paragraphs: [
      'The AJ-PFPT-182 Platform Trolley is a reliable material transport system designed for efficient movement of heavy loads across warehouses and industrial facilities.',
    ],
  },
};
